const selectUseDarkTheme = state => state.settingsStore.useDarkTheme;

export const selectors = {
    selectUseDarkTheme
}